module.exports = __webpack_public_path__ + "img/icone-contato.1862501b.svg";